import moment from 'moment-timezone';

import { Program, ProgramPlaylist, ProgramPreview, TrackPreview } from './programs.model';

export interface ProgramApi {
  idprogram: number;
  program_name: string;
  program_color: string;
  program_estimated_duration: number; // seconds
  idtrack_intro: number;
  idtrack_extro: number;
  created_at: string;
  playlists_number: number;
  playlists?: ProgramPlaylistApi[];
}

export function convertToProgram(program: ProgramApi): Program {
  return {
    id: program.idprogram,
    name: program.program_name,
    color: program.program_color,
    estimatedDuration: program.program_estimated_duration,
    idTrackIntro: program.idtrack_intro,
    idTrackExtro: program.idtrack_extro,
    createdAt: moment(program.created_at),
    playlistsNumber: program.playlists_number,
    playlists: program.playlists
      ? program.playlists.map(convertToPlaylist).sort((a, b) => a.position - b.position)
      : null,
  };
}

export interface ProgramPlaylistApi {
  idplaylist: number;
  idprogramplaylist: number;
  playlist_name: string;
  playlist_color: string;
  tracks_number: number;
  position: number;
  playlist_estimated_duration: number;
  playlist_type: 'manual' | 'dynamic';
  sorting: 'Sequential' | 'Random';
}

export function convertToPlaylist(playlist: ProgramPlaylistApi): ProgramPlaylist {
  return {
    idPlaylist: playlist.idplaylist,
    idProgramPlaylist: playlist.idprogramplaylist,
    color: playlist.playlist_color,
    playlistName: playlist.playlist_name,
    tracksNumber: playlist.tracks_number,
    position: playlist.position,
    playlistEstimatedDuration: playlist.playlist_estimated_duration,
    type: playlist.playlist_type,
    sorting: playlist.sorting,
  };
}

export interface ProgramPreviewApi {
  tracks: TrackPreview[];
  playlist_name: string;
  playlist_type: 'manual' | 'dynamic';
  playlist_color: string;
  position: number;
}

export function convertToProgramPreview(preview: ProgramPreviewApi): ProgramPreview {
  return {
    tracks: preview.tracks,
    playlist: {
      name: preview.playlist_name,
      type: preview.playlist_type,
      color: preview.playlist_color,
    },
    position: preview.position,
  };
}
